export const countries = ['North America', 'South America', 'Europe', 'Asia', 'Africa', 'Australia']
export const countriesAbbr = ['NA', 'LA', 'EU', 'AS', 'AF', 'AU', 'AF', 'AU']
export const naLanguages = ['English', '\u0045\u0073\u0070\u0061\u00f1\u006f\u006c', 'Français']
export const naLanguagesAbbr = ['EN', 'ES', 'FR']
export const laLanguages = ['\u0045\u0073\u0070\u0061\u00f1\u006f\u006c', 'Português', 'English']
export const laLanguagesAbbr = ['ES', 'PT', 'EN']
export const euLanguages = ['English', '\u0045\u0073\u0070\u0061\u00f1\u006f\u006c', 'Norsk', 'Français', 'Português', 'Italiano']
export const euLanguagesAbbr = ['EN', 'ES', 'NO', 'FR', 'PT', 'IT']
export const asLanguages = ['English']
export const asLanguagesAbbr = ['EN']
export const afLanguages = ['English']
export const afLanguagesAbbr = ['EN']
export const auLanguages = ['English']
export const auLanguagesAbbr = ['EN']
export const colorOptions = ['#ff2d55', '#ff6348', '#ffbb02', '#2dda75', '#5ac8fa', '#5251fe', '#af33eb', '#2f3542']
export const colorMatchs = ['#ff566f', '#ff7f50', '#ffcc00', '#29e778', '#99dfff', '#567eff', '#c56cf0', '#57606f']

export const naQuestionsEnglish = [{
  question: 'Which one is ^name^\'s favorite food?',
  options: ['Pizza \ud83c\udf55', 'Burger \ud83c\udf54', 'Sushi \ud83c\udf63', 'Taco \ud83c\udf2e', 'Ramen \ud83c\udf5c'],
  color: 0
}, {
  question: 'How long was ^name^\'s longest relationship? \ud83d\udc95',
  options: ['A week', 'A month', 'Two years', 'And counting'],
  color: 1
}, {
  question: 'What is one weird talent ^name^ has?',
  options: ['Eyebrow dancing', 'Epic tongue tricks', 'Moving eyes independently', 'Wiggling ears'],
  color: 2
}, {
  question: 'What does ^name^ dislike the most? \ud83d\ude21',
  options: ['Going to the dentist', 'Slow internet', 'Loud phone games', 'Homework'],
  color: 3
}, {
  question: 'If ^name^ could have one superpower, which would it be?',
  options: ['Flight', 'Invisibility', 'Teleportation', 'Telepathy', 'Super speed'],
  color: 4
}, {
  question: 'Which celeb would ^name^ like as a sibling?',
  options: ['Zendaya', 'Billie Eilish', 'Lil Nas X', 'Dua Lipa', 'Justin Bieber'],
  color: 5
}, {
  question: 'Where does ^name^ spend the most time? \ud83d\udcf1',
  options: ['FYP (For you page)', 'Feed', 'Reels', 'Stories', 'Explore'],
  color: 6
}, {
  question: 'Where does ^name^ want to travel the most? \ud83c\udf0e',
  options: ['Paris', 'New York', 'Bali', 'Tokyo', 'Tulum'],
  color: 7
}, {
  question: 'How tall is ^name^?',
  options: ['Less than 5\'3ft (160cm)', '5\'4ft (161cm) - 5\'8ft (172cm)', '5\'9ft (173cm) - 5\'11ft (181cm)', '6\'0ft (182cm) and up'],
  color: 0
}, {
  question: 'When is ^name^\'s birthday? \ud83c\udf82',
  options: ['September 9th', 'July 7th', 'March 10th', 'February 24th', 'September 19th'],
  color: 1
}, {
  question: 'What is ^name^\'s favorite song right now? \ud83c\udfa7',
  options: ['Song 1', 'Song 2'],
  color: 2
}, {
  question: 'Does ^name^ believe in ghosts? \ud83d\udc7b',
  options: ['Big time', 'A little', 'Not at all'],
  color: 3
}, {
  question: 'How old is ^name^?',
  options: ['18', '20', '22', '24', '26'],
  color: 4
}, {
  question: 'How many times does ^name^ workout per week? \ud83d\udcaa',
  options: ['Once', '2 to 3 times', 'Four times', 'Every day', 'Never'],
  color: 5
}, {
  question: 'Does ^name^ eat his veggies? \ud83e\udd57',
  options: ['Every bit', 'Barely', 'By no means'],
  color: 6
}, {
  question: 'Which color are ^name^\'s eyes? \ud83d\udc41',
  options: ['Blue', 'Amber', 'Brown', 'Hazel', 'Green'],
  color: 7
}, {
  question: 'Does ^name^ like to nap? \ud83d\ude34',
  options: ['Very much', 'Sometimes', 'Definitely not'],
  color: 0
}, {
  question: 'Which is ^name^\'s natural hair color? \ud83e\udd84',
  options: ['Black', 'Dark brown', 'Light brown', 'Blond', 'Gray', 'Red'],
  color: 2
}, {
  question: 'Does ^name^ sing in the shower? \ud83c\udfa4',
  options: ['All the time', 'Sometimes', 'Never'],
  color: 3
}, {
  question: 'What has been the most fun activity in ^name^\'s life so far? \ud83e\udd2a',
  options: ['Backyard camping', 'Water balloon fighting', 'Hiking', 'Night swimming', 'Ice skating'],
  color: 4
}, {
  question: 'What would ^name^ like to be known for? \ud83c\udfc6',
  options: ['Music', 'Scientific achievements', 'Crazy adventures', 'Unique style', 'Art'],
  color: 5
}, {
  question: 'Which one is ^name^\'s happy place? \ud83c\udf08',
  options: ['Cinema', 'Home', 'The beach', 'Gym', 'School'],
  color: 6
}, {
  question: 'How many pairs of shoes does ^name^ own? \ud83d\udc5f',
  options: ['1 pair', '5 pairs', '10 pairs', '+20 pairs'],
  color: 7
}, {
  question: 'Does ^name^ believe in aliens? \ud83d\udef8',
  options: ['Definitely', 'Possibly', 'Not really'],
  color: 0
}, {
  question: 'How many siblings does ^name^ have?',
  options: ['Only child', '1', '2', '3', '4', '+5'],
  color: 1
}, {
  question: 'If ^name^ were an animal, which one would it be?',
  options: ['Lion \ud83e\udd81', 'Eagle \ud83e\udd85', 'Bear \ud83d\udc3b', 'Dolphin \ud83d\udc2c', 'Shark \ud83e\udd88'],
  color: 2
}, {
  question: 'Which one is ^name^?',
  options: ['Creator', 'Follower'],
  color: 3
}, {
  question: 'Does ^name^ like to cook? \ud83c\udf73',
  options: ['Loves it', 'Sometimes', 'Not at all'],
  color: 4
}, {
  question: 'How many hours per day does ^name^ spend on TikTok? \u231b\ufe0f',
  options: ['None at all', '1 hour', '4 hours', 'Day-and-night'],
  color: 5
}, {
  question: 'Which one is ^name^\'s ultimate dream job? \ud83e\udd29',
  options: ['Doctor', 'YouTuber', 'Astronaut', 'Fashion model', 'TikToker'],
  color: 6
}, {
  question: 'What is ^name^\'s most hated food? \ud83e\udd22',
  options: ['Olives', 'Pickles', 'Sushi', 'Eggplant', 'Avocados'],
  color: 7
}, {
  question: 'What is one thing ^name^ cannot live without? \ud83d\ude35',
  options: ['Wi-Fi', 'Phone', 'Pet', 'Coffee'],
  color: 0
}, {
  question: 'What book has impacted ^name^ the most? \ud83d\udcda',
  options: ['Harry Potter', 'The Hunger Games', 'To Kill a Mockingbird', 'I\'ll Give You the Sun', 'The Fault in Our Stars'],
  color: 1
}, {
  question: 'How many countries has ^name^ been to? \ud83c\udf0e',
  options: ['1', '3', '5', '+10'],
  color: 2
}, {
  question: '\u270d\ufe0f Add your own question',
  options: ['', ''],
  color: 3
}]

export const naQuestionsSpanish = [{
  question: '¿Cual es la comida favorita de ^name^?',
  options: ['Pizza \ud83c\udf55', 'Hamburguesa \ud83c\udf54', 'Sushi \ud83c\udf63', 'Taco \ud83c\udf2e', 'Ramen \ud83c\udf5c'],
  color: 0
}, {
  question: '¿Cuanto tiempo duro la relacion mas larga de ^name^? \ud83d\udc95',
  options: ['Una semana', 'Un mes', 'Dos a\u00f1os', 'Y contando'],
  color: 1
}, {
  question: '¿Que talento extra\u00f1o tiene ^name^?',
  options: ['Trucos con las cejas', 'Trucos con la lengua', 'Ojos locos', 'Mueve sus orejas'],
  color: 2
}, {
  question: '¿Que es lo que menos le gusta a ^name^? \ud83d\ude21',
  options: ['Ir al dentista', 'Internet lento', 'Juegos mobiles ruidosos', 'Hacer tareas'],
  color: 3
}, {
  question: '¿Que superpoder elegiria ^name^?',
  options: ['Volar', 'Invisibilidad', 'Teletransportarse', 'Telepatia', 'Super velocidad'],
  color: 4
}, {
  question: '¿Que celebridad le gustaria a ^name^ como herman@?',
  options: ['Zendaya', 'Billie Eilish', 'Lil Nas X', 'Dua Lipa', 'Justin Bieber'],
  color: 5
}, {
  question: '¿De que color son los ojos de ^name^? \ud83d\udc41',
  options: ['Azul', 'Ambar', 'Marron', 'Avellana', 'Verde'],
  color: 6
}, {
  question: '¿A donde le gustaria mas viajar a ^name^? \ud83c\udf0e',
  options: ['Paris', 'New York', 'Bali', 'Tokio', 'Tulum'],
  color: 7
}, {
  question: '¿Cuanto mide ^name^?',
  options: ['Menos de 1.60m', '1.61m - 1.72m', '1.73m - 1.81m', 'Mas de 1.82m'],
  color: 0
}, {
  question: '¿Cuando cumple a\u00f1os ^name^? \ud83c\udf82',
  options: ['9 de Septiembre', '7 de Julio', '10 de Marzo', '24 de Febrero', '19 de Septiembre'],
  color: 1
}, {
  question: '¿Cual es la cancion favorita de ^name^ actualmente? \ud83c\udfa7',
  options: ['Cancion 1', 'Cancion 2'],
  color: 2
}, {
  question: '¿^name^ cree en fantasmas? \ud83d\udc7b',
  options: ['Si', 'Tal vez', 'Para nada'],
  color: 3
}, {
  question: '¿Que edad tiene ^name^?',
  options: ['18', '20', '22', '24', '26'],
  color: 4
}, {
  question: '¿Cuantas veces a la semana entrena ^name^? \ud83d\udcaa',
  options: ['Solo una', '2 o 3 veces', 'Cuatro veces', 'Todos los dias', 'Nunca'],
  color: 5
}, {
  question: '¿^name^ come sus vegetales? \ud83e\udd57',
  options: ['Hasta el ultimo bocado', 'Solo un poco', 'De ninguna manera'],
  color: 6
}, {
  question: '¿Donde pasa ^name^ la mayor parte del tiempo? \ud83d\udcf1',
  options: ['Para ti (TikTok)', 'Feed (Instagram)', 'Reels', 'Historias', 'Tendencias'],
  color: 7
}, {
  question: '¿A ^name^ le gusta tomar siestas? \ud83d\ude34',
  options: ['Muchisimo', 'A veces', 'No'],
  color: 0
}, {
  question: '¿Cual es el color natural del cabello de ^name^? \ud83e\udd84',
  options: ['Negro', 'Marron oscuro', 'Marron claro', 'Rubio', 'Gris', 'Rojo'],
  color: 2
}, {
  question: '¿^name^ canta en la ducha? \ud83c\udfa4',
  options: ['Siempre', 'A veces', 'Nunca'],
  color: 3
}, {
  question: '¿Cual ha sido la actividad mas divertida para ^name^? \ud83e\udd2a',
  options: ['Camping en el patio trasero', 'Pelea de globos de agua', 'Senderismo', 'Nadar de noche', 'Ice skating'],
  color: 4
}, {
  question: '¿Por que le gustaria ser famoso a ^name^? \ud83c\udfc6',
  options: ['Musica', 'Logros cientificos', 'Locas aventuras', 'Estilo unico', 'Arte'],
  color: 5
}, {
  question: '¿Cual de estos es el lugar feliz de ^name^? \ud83c\udf08',
  options: ['Cine', 'Casa', 'La playa', 'Gimnasio', 'Escuela'],
  color: 6
}, {
  question: '¿Cuantos pares de zapatos tiene ^name^? \ud83d\udc5f',
  options: ['1 par', '5 pares', '10 pares', '+20 pares'],
  color: 7
}, {
  question: '¿^name^ cree en los extraterrestres? \ud83d\udef8',
  options: ['Muchisimo', 'Quizas', 'Para nada'],
  color: 0
}, {
  question: '¿Cuantos herman@s tiene ^name^?',
  options: ['Hijo unico', '1', '2', '3', '4', '+5'],
  color: 1
}, {
  question: 'Si ^name^ pudiera ser un animal, ¿cual seria?',
  options: ['Leon \ud83e\udd81', 'Aguila \ud83e\udd85', 'Oso \ud83d\udc3b', 'Delfin \ud83d\udc2c', 'Tiburon \ud83e\udd88'],
  color: 2
}, {
  question: '¿Cual es ^name^?',
  options: ['Creador', 'Seguidor'],
  color: 3
}, {
  question: '¿A ^name^ le gusta cocinar? \ud83c\udf73',
  options: ['Le encanta', 'A veces', 'Para nada'],
  color: 4
}, {
  question: '¿Cuantas horas al día pasa ^name^ en TikTok? \u231b\ufe0f',
  options: ['Ninguna', '1 hora', '4 horas', 'Dia y noche'],
  color: 5
}, {
  question: '¿Cual es el trabajo so\u00f1ado de ^name^? \ud83e\udd29',
  options: ['Doctor', 'YouTuber', 'Astronauta', 'Modelo', 'TikToker'],
  color: 6
}, {
  question: '¿Cual es la comida que mas odia ^name^? \ud83e\udd22',
  options: ['Aceitunas', 'Pepinillos', 'Sushi', 'Berenjenas', 'Aguacates'],
  color: 7
}, {
  question: '¿Que es algo sin lo que ^name^ no puede vivir? \ud83d\ude35',
  options: ['Wi-Fi', 'Celular', 'Mascota', 'Cafe'],
  color: 0
}, {
  question: '¿Que libro ha impactado mas a ^name^? \ud83d\udcda',
  options: ['Harry Potter', 'Los Juegos del Hambre', 'Matar a un Ruise\u00f1or', 'Te Daria el Sol', 'Bajo la Misma Estrella'],
  color: 1
}, {
  question: '¿En cuantos paises ha estado ^name^? \ud83c\udf0e',
  options: ['1', '3', '5', '+10'],
  color: 2
}, {
  question: '\u270d\ufe0f Agrega tu propia pregunta',
  options: ['', ''],
  color: 3
}]

export const naQuestionsFrench = [{
  question: '\ud83d\udcc5 Quand est l\'anniversaire d\'^name^?',
  options: ['10 janvier', '23 septembre', '3 octobre', '27 décembre'],
  color: 0
}, {
  question: '^name^ n\'a jamais ...',
  options: ['\ud83d\ude37 Cassé un os', '\ud83d\udebd Laissé tomber le téléphone dans les toilettes', '\ud83d\ude34 Resté éveillé plus de 24 heures', '\ud83c\udf55 Mangé toute une pizza toute seule'],
  color: 1
}, {
  question: '\ud83d\udc6a Combien de frères et sœurs ^name^ a-t-il?',
  options: ['Aucun', '5', '2', '1'],
  color: 2
}, {
  question: '\ud83c\udf6d Si ^name^ pouvait se réveiller avec une couleur de cheveux permanente complètement différente, ce serait quoi?',
  options: ['Rose', 'Bleu', 'Violet', 'Vert', 'Rouge'],
  color: 3
}, {
  question: '^name^ est-il célibataire ou pris/prise? \ud83d\udc91',
  options: ['Célibataire', 'Pris/Prise'],
  color: 4
}, {
  question: '\ud83c\udf7f Quelle est la série préférée d\'^name^ sur Netflix?',
  options: ['Stranger Things', 'Friends', '13 Reasons Why', 'Narcos'],
  color: 5
}, {
  question: '\ud83d\udcb0 Si ^name^ a une heure pour dépenser 1 million \ud83d\udcb2, où pensez-vous qu\'il / elle irait en premier?',
  options: ['\ud83d\udecd\ufe0f Un magasin de créateurs', '\ud83c\udf63 Un restaurant de luxe', '\ud83d\ude97 Un concessionnaire de voitures de luxe'],
  color: 6
}, {
  question: '\ud83d\udc6a Combien d\'enfants ^name^ aura-t-il?',
  options: ['10', '3', '2', '1', 'Aucun'],
  color: 7
}, {
  question: '\u2708\ufe0f Si ^name^ pouvait aller n\'importe où, ce serait ...',
  options: ['Paris', 'Hawaii', 'New York', 'Tokio'],
  color: 0
}, {
  question: '\ud83c\udf68 Quelle est la saveur de crème glacée préférée d\'^name^?',
  options: ['Vanille', 'Chocolat', 'Pâte à biscuits', 'Fraise', 'Pépites de chocolat à la menthe'],
  color: 1
}, {
  question: 'Si ^name^ pouvait être un animal pendant une journée, lequel serait-il?',
  options: ['\ud83d\udc2c Dauphin', '\ud83d\udc07 Lapin', '\ud83e\udd88 Requin', '\ud83d\udc3c Panda'],
  color: 2
}, {
  question: 'Si ^name^ devait manger la même nourriture pour le dîner tous les jours, que choisirait-il?',
  options: ['\ud83c\udf54 Burger', '\ud83c\udf63 Sushi', '\ud83c\udf55 Pizza', '\ud83c\udf2f Burrito'],
  color: 3
}, {
  question: '\ud83c\udfa5 Quel est le YouTuber préféré d\'^name^?',
  options: ['David Dobrik', 'emma chamberlain', 'The ACE Family', 'Shane Dawson'],
  color: 4
}, {
  question: '\ud83c\udf81 Quel est le meilleur cadeau que ^name^ a reçu?',
  options: ['\ud83d\udc08 Un animal de compagnie', '\ud83d\ude18 Un baiser de son béguin', '\u2708\ufe0f Un voyage surprise', '\ud83d\udcf1 Un téléphone'],
  color: 5
}, {
  question: 'Quel est le sport préféré d\'^name^?',
  options: ['\u26bd Football', '\ud83d\udeb4 Cycling', '\ud83c\udfc9 Rugby', '\ud83c\udfbe Tennis'],
  color: 6
}, {
  question: '\ud83d\udc75 Quel âge a ^name^? \ud83d\udc74',
  options: ['15', '21', '30', '32'],
  color: 7
}, {
  question: 'Si ^name^ pouvait instantanément parler couramment une autre langue, quelle serait cette langue?',
  options: ['\ud83c\uddea\ud83c\uddf8 Espagnol', '\ud83c\udde9\ud83c\uddea Allemand', '\ud83c\uddef\ud83c\uddf5 Japonais', '\ud83c\uddee\ud83c\uddf9 Italien'],
  color: 0
}, {
  question: '\ud83d\ude31 De quoi ^name^ à-t-il le plus peur?',
  options: ['\ud83d\udc1b Bogues', '\ud83d\udd77\ufe0f Les araignées', '\ud83d\udc00 Rats et souris'],
  color: 1
}, {
  question: '\ud83d\udcdb Quel est le deuxième prénom d\'^name^?',
  options: ['James', 'Louise', 'Lee', 'Anne/Ann'],
  color: 2
}, {
  question: '\ud83d\uddef\ufe0f Si ^name^ pouvait être un personnage de dessin animé pendant un jour, ce serait qui?',
  options: ['Rick (Rick & Morty)', 'Phineas/Ferb', 'Gumball', 'Finn/Jake/Bubblegum (Adventure Time)'],
  color: 3
}, {
  question: 'Qui est le préféré d\'^name^, maman ou papa?',
  options: ['\ud83d\udc69 Maman', '\ud83d\udc68 Papa'],
  color: 4
}, {
  question: 'Quel est le métier de rêve d\'^name^?',
  options: ['\ud83d\udc68\u200d\ud83d\ude80 Astronaute', '\ud83c\udfa5 Célèbre acteur/actrice', '\ud83c\udf0c Jedi', '\ud83d\udd2c Scientifique'],
  color: 5
}, {
  question: '\ud83c\udfac Quel est le film préféré d\'^name^ en 2019 jusqu\'à présent?',
  options: ['Avengers: Endgame', 'It: Chapter Two', 'Toy Story 4', 'Spider-Man: Far From Home'],
  color: 6
}, {
  question: 'Qu\'est-ce que ^name^ préférerait gagner?',
  options: ['\ud83c\udfc6 Le prix nobel de la Paix', '\ud83d\udcfd\ufe0f Un Academy Award', '\ud83c\udfc5 Une médaille olympique'],
  color: 7
}, {
  question: '\ud83d\udcfa Quelle est l\'émission de télévision préférée d\'^name^?',
  options: ['The Office', 'Lost', 'Breaking Bad', 'FRIENDS', 'Game of Thrones'],
  color: 0
}, {
  question: '\ud83c\udf08 Quelle est la couleur préférée d\'^name^?',
  options: ['Rose', 'Bleu', 'Violet', 'Rouge', 'Vert'],
  color: 1
}, {
  question: '\ud83c\udf92 À combien d\'écoles ^name^ est-il allé?',
  options: ['6', '1', '2', '5'],
  color: 2
}, {
  question: '\u270d\ufe0f Ajoutez votre propre question',
  options: ['', ''],
  color: 3
}]

export const laQuestionsSpanish = [{
  question: '¿Cual es la comida favorita de ^name^?',
  options: ['Pizza \ud83c\udf55', 'Hamburguesa \ud83c\udf54', 'Sushi \ud83c\udf63', 'Taco \ud83c\udf2e', 'Ramen \ud83c\udf5c'],
  color: 0
}, {
  question: '¿Cuanto tiempo duro la relacion mas larga de ^name^? \ud83d\udc95',
  options: ['Una semana', 'Un mes', 'Dos a\u00f1os', 'Y contando'],
  color: 1
}, {
  question: '¿Que talento extra\u00f1o tiene ^name^?',
  options: ['Trucos con las cejas', 'Trucos con la lengua', 'Ojos locos', 'Mueve sus orejas'],
  color: 2
}, {
  question: '¿Que es lo que menos le gusta a ^name^? \ud83d\ude21',
  options: ['Ir al dentista', 'Internet lento', 'Juegos mobiles ruidosos', 'Hacer tareas'],
  color: 3
}, {
  question: '¿Que superpoder elegiria ^name^?',
  options: ['Volar', 'Invisibilidad', 'Teletransportarse', 'Telepatia', 'Super velocidad'],
  color: 4
}, {
  question: '¿Que celebridad le gustaria a ^name^ como herman@?',
  options: ['Zendaya', 'Billie Eilish', 'Lil Nas X', 'Dua Lipa', 'Justin Bieber'],
  color: 5
}, {
  question: '¿De que color son los ojos de ^name^? \ud83d\udc41',
  options: ['Azul', 'Ambar', 'Marron', 'Avellana', 'Verde'],
  color: 6
}, {
  question: '¿A donde le gustaria mas viajar a ^name^? \ud83c\udf0e',
  options: ['Paris', 'New York', 'Bali', 'Tokio', 'Tulum'],
  color: 7
}, {
  question: '¿Cuanto mide ^name^?',
  options: ['Menos de 1.60m', '1.61m - 1.72m', '1.73m - 1.81m', 'Mas de 1.82m'],
  color: 0
}, {
  question: '¿Cuando cumple a\u00f1os ^name^? \ud83c\udf82',
  options: ['9 de Septiembre', '7 de Julio', '10 de Marzo', '24 de Febrero', '19 de Septiembre'],
  color: 1
}, {
  question: '¿Cual es la cancion favorita de ^name^ actualmente? \ud83c\udfa7',
  options: ['Cancion 1', 'Cancion 2'],
  color: 2
}, {
  question: '¿^name^ cree en fantasmas? \ud83d\udc7b',
  options: ['Si', 'Tal vez', 'Para nada'],
  color: 3
}, {
  question: '¿Que edad tiene ^name^?',
  options: ['18', '20', '22', '24', '26'],
  color: 4
}, {
  question: '¿Cuantas veces a la semana entrena ^name^? \ud83d\udcaa',
  options: ['Solo una', '2 o 3 veces', 'Cuatro veces', 'Todos los dias', 'Nunca'],
  color: 5
}, {
  question: '¿^name^ come sus vegetales? \ud83e\udd57',
  options: ['Hasta el ultimo bocado', 'Solo un poco', 'De ninguna manera'],
  color: 6
}, {
  question: '¿Donde pasa ^name^ la mayor parte del tiempo? \ud83d\udcf1',
  options: ['Para ti (TikTok)', 'Feed (Instagram)', 'Reels', 'Historias', 'Tendencias'],
  color: 7
}, {
  question: '¿A ^name^ le gusta tomar siestas? \ud83d\ude34',
  options: ['Muchisimo', 'A veces', 'No'],
  color: 0
}, {
  question: '¿Cual es el color natural del cabello de ^name^? \ud83e\udd84',
  options: ['Negro', 'Marron oscuro', 'Marron claro', 'Rubio', 'Gris', 'Rojo'],
  color: 2
}, {
  question: '¿^name^ canta en la ducha? \ud83c\udfa4',
  options: ['Siempre', 'A veces', 'Nunca'],
  color: 3
}, {
  question: '¿Cual ha sido la actividad mas divertida para ^name^? \ud83e\udd2a',
  options: ['Camping en el patio trasero', 'Pelea de globos de agua', 'Senderismo', 'Nadar de noche', 'Ice skating'],
  color: 4
}, {
  question: '¿Por que le gustaria ser famoso a ^name^? \ud83c\udfc6',
  options: ['Musica', 'Logros cientificos', 'Locas aventuras', 'Estilo unico', 'Arte'],
  color: 5
}, {
  question: '¿Cual de estos es el lugar feliz de ^name^? \ud83c\udf08',
  options: ['Cine', 'Casa', 'La playa', 'Gimnasio', 'Escuela'],
  color: 6
}, {
  question: '¿Cuantos pares de zapatos tiene ^name^? \ud83d\udc5f',
  options: ['1 par', '5 pares', '10 pares', '+20 pares'],
  color: 7
}, {
  question: '¿^name^ cree en los extraterrestres? \ud83d\udef8',
  options: ['Muchisimo', 'Quizas', 'Para nada'],
  color: 0
}, {
  question: '¿Cuantos herman@s tiene ^name^?',
  options: ['Hijo unico', '1', '2', '3', '4', '+5'],
  color: 1
}, {
  question: 'Si ^name^ pudiera ser un animal, ¿cual seria?',
  options: ['Leon \ud83e\udd81', 'Aguila \ud83e\udd85', 'Oso \ud83d\udc3b', 'Delfin \ud83d\udc2c', 'Tiburon \ud83e\udd88'],
  color: 2
}, {
  question: '¿Cual es ^name^?',
  options: ['Creador', 'Seguidor'],
  color: 3
}, {
  question: '¿A ^name^ le gusta cocinar? \ud83c\udf73',
  options: ['Le encanta', 'A veces', 'Para nada'],
  color: 4
}, {
  question: '¿Cuantas horas al día pasa ^name^ en TikTok? \u231b\ufe0f',
  options: ['Ninguna', '1 hora', '4 horas', 'Dia y noche'],
  color: 5
}, {
  question: '¿Cual es el trabajo so\u00f1ado de ^name^? \ud83e\udd29',
  options: ['Doctor', 'YouTuber', 'Astronauta', 'Modelo', 'TikToker'],
  color: 6
}, {
  question: '¿Cual es la comida que mas odia ^name^? \ud83e\udd22',
  options: ['Aceitunas', 'Pepinillos', 'Sushi', 'Berenjenas', 'Aguacates'],
  color: 7
}, {
  question: '¿Que es algo sin lo que ^name^ no puede vivir? \ud83d\ude35',
  options: ['Wi-Fi', 'Celular', 'Mascota', 'Cafe'],
  color: 0
}, {
  question: '¿Que libro ha impactado mas a ^name^? \ud83d\udcda',
  options: ['Harry Potter', 'Los Juegos del Hambre', 'Matar a un Ruise\u00f1or', 'Te Daria el Sol', 'Bajo la Misma Estrella'],
  color: 1
}, {
  question: '¿En cuantos paises ha estado ^name^? \ud83c\udf0e',
  options: ['1', '3', '5', '+10'],
  color: 2
}, {
  question: '\u270d\ufe0f Agrega tu propia pregunta',
  options: ['', ''],
  color: 3
}]

export const laQuestionsPortuguese = [{
  question: '\ud83d\udcc5 Quando é o aniversário de ^name^?',
  options: ['10 de janeiro', '23 de setembro', '3 de outubro', '27 de dezembro'],
  color: 0
}, {
  question: '^name^ nunca...',
  options: ['\ud83d\ude37 Um osso foi quebrado', '\ud83d\udebd Ele largou o celular no banheiro', '\ud83d\ude34 Ela ficou acordad@ por mais de 24 horas', '\ud83c\udf55 Ele comeu uma pizza inteira'],
  color: 1
}, {
  question: '\ud83d\udc6a ¿Quant@s irmãos/irmãs você tem ^name^?',
  options: ['Nenhuma', '5', '2', '1'],
  color: 2
}, {
  question: '\ud83c\udf6d Se ^name^ tivesse que escolher uma nova cor de cabelo (para sempre), que cor ele escolheria?',
  options: ['Rose', 'Azul', 'Roxo', 'Verde', 'Vermelho'],
  color: 3
}, {
  question: '^name^ está solteiro ou com um parceiro? \ud83d\udc91',
  options: ['Solteiro', 'Com parceiro'],
  color: 4
}, {
  question: '\ud83c\udf7f Qual é a série favorita de ^name^ na Netflix?',
  options: ['Stranger Things', 'Friends', '13 Reasons Why', 'Narcos'],
  color: 5
}, {
  question: '\ud83d\udcb0 Se ^name^ tivesse uma hora para gastar 1 milhão \ud83d\udcb2, para onde ele/ela iria?',
  options: ['\ud83d\udecd\ufe0f Uma loja de grife', '\ud83c\udf63 Para um restaurante', '\ud83d\ude97 Para uma concessionária de carros'],
  color: 6
}, {
  question: '\ud83d\udc6a ¿Quantos filhos ^name^ gostaria de ter?',
  options: ['10', '3', '2', '1', 'Nenhuma'],
  color: 7
}, {
  question: '\u2708\ufe0f Se ^name^ pudesse ir a qualquer lugar, para onde ele iria?',
  options: ['Paris', 'Havaí', 'Nova York', 'Tokio'],
  color: 0
}, {
  question: '\ud83c\udf68 Qual é o sabor favorito de sorvete de ^name^?',
  options: ['Baunilha', 'Chocolate', 'Amêndoa', 'Morango', 'Creme de Chocolate'],
  color: 1
}, {
  question: 'Que animal ^name^ gostaria de ser por um dia?',
  options: ['\ud83d\udc2c Golfinho', '\ud83d\udc07 Coelho', '\ud83e\udd88 Tubarão', '\ud83d\udc3c Urso panda'],
  color: 2
}, {
  question: 'Se ^name^ tivesse que comer o mesmo prato todos os dias, que comida seria?',
  options: ['\ud83c\udf54 Hamburger', '\ud83c\udf63 Sushi', '\ud83c\udf55 Pizza', '\ud83c\udf2f Burrito'],
  color: 3
}, {
  question: '\ud83c\udfa5 Qual é o YouTuber favorito de ^name^?',
  options: ['David Dobrik', 'emma chamberlain', 'The ACE Family', 'Shane Dawson'],
  color: 4
}, {
  question: '\ud83c\udf81 Qual é o melhor presente que ^name^ recebeu?',
  options: ['\ud83d\udc08 Um mascote', '\ud83d\ude18 Um beijo de sua paixão', '\u2708\ufe0f Uma viagem surpresa'],
  color: 5
}, {
  question: 'Qual é o esporte favorito de ^name^?',
  options: ['\u26bd Futebol', '\ud83c\udfc8 Jiu Jitsu', '\ud83c\udfc0 Basquetebol', '\ud83c\udfd0 Vôlei'],
  color: 6
}, {
  question: '\ud83d\udc75 Quantos anos ^name^ tem? \ud83d\udc74',
  options: ['15', '21', '30', '32'],
  color: 7
}, {
  question: 'Se ^name^ pudesse aprender instantaneamente um novo idioma, qual idioma ele/ela escolheria?',
  options: ['\ud83c\uddeb\ud83c\uddf7 Frances', '\ud83c\udde9\ud83c\uddea Alemão', '\ud83c\uddef\ud83c\uddf5 Japonês', '\ud83c\uddee\ud83c\uddf9 Italiano'],
  color: 0
}, {
  question: '\ud83d\ude31 Qual é o maior medo de ^name^?',
  options: ['\ud83d\udc1b Insetos', '\ud83d\udd77\ufe0f Aranhas', '\ud83d\udc00 Ratos e ratos'],
  color: 1
}, {
  question: '\ud83d\udcdb Qual é o nome do meio de ^name^?',
  options: ['James', 'Louise', 'Lee', 'Anne/Ann'],
  color: 2
}, {
  question: '\ud83d\uddef\ufe0f Se ^name^ pudesse ser um personagem de desenho animado por um dia, qual seria?',
  options: ['Rick (Rick & Morty)', 'Phineas/Ferb', 'Gumball', 'Finn/Jake/Bubblegum (Adventure Time)'],
  color: 3
}, {
  question: 'Quem é o favorito de ^name^, Mama ou Papa?',
  options: ['\ud83d\udc69 Mama', '\ud83d\udc68 Papa'],
  color: 4
}, {
  question: 'Qual é o emprego dos sonhos de ^name^?',
  options: ['\ud83d\udc68\u200d\ud83d\ude80 Astronauta', '\ud83c\udfa5 Ator/actriz famoso', '\ud83c\udf0c Jedi', '\ud83d\udd2c Cientista'],
  color: 5
}, {
  question: '\ud83c\udfac Qual é o filme favorito de ^name^ em 2019?',
  options: ['Avengers: Endgame', 'It: Chapter Two', 'Toy Story 4', 'Spider-Man: Far From Home'],
  color: 6
}, {
  question: 'Qual dos seguintes prêmios ^name^ prefere ganhar?',
  options: ['\ud83c\udfc6 Premio Nobel da Paz', '\ud83d\udcfd\ufe0f Prémio Oscar', '\ud83c\udfc5 Medalha Olímpica'],
  color: 7
}, {
  question: '\ud83d\udcfa Qual é a série de TV favorita de ^name^?',
  options: ['The Office', 'Lost', 'Breaking Bad', 'Friends', 'Game of Thrones'],
  color: 0
}, {
  question: '\ud83c\udf08 Qual é a cor favorita de ^name^?',
  options: ['Rose', 'Azul', 'Roxo', 'Vermelho', 'Verde'],
  color: 1
}, {
  question: '\ud83c\udf92 Quantas escolas ^name^ frequentou?',
  options: ['6', '1', '2', '5'],
  color: 2
}, {
  question: '\u270d\ufe0f Adicione sua própria pergunta',
  options: ['', ''],
  color: 3
}]

export const laQuestionsEnglish = [{
  question: 'Which one is ^name^\'s favorite food?',
  options: ['Pizza \ud83c\udf55', 'Burger \ud83c\udf54', 'Sushi \ud83c\udf63', 'Taco \ud83c\udf2e', 'Ramen \ud83c\udf5c'],
  color: 0
}, {
  question: 'How long was ^name^\'s longest relationship? \ud83d\udc95',
  options: ['A week', 'A month', 'Two years', 'And counting'],
  color: 1
}, {
  question: 'What is one weird talent ^name^ has?',
  options: ['Eyebrow dancing', 'Epic tongue tricks', 'Moving eyes independently', 'Wiggling ears'],
  color: 2
}, {
  question: 'What does ^name^ dislike the most? \ud83d\ude21',
  options: ['Going to the dentist', 'Slow internet', 'Loud phone games', 'Homework'],
  color: 3
}, {
  question: 'If ^name^ could have one superpower, which would it be?',
  options: ['Flight', 'Invisibility', 'Teleportation', 'Telepathy', 'Super speed'],
  color: 4
}, {
  question: 'Which celeb would ^name^ like as a sibling?',
  options: ['Zendaya', 'Billie Eilish', 'Lil Nas X', 'Dua Lipa', 'Justin Bieber'],
  color: 5
}, {
  question: 'Where does ^name^ spend the most time? \ud83d\udcf1',
  options: ['FYP (For you page)', 'Feed', 'Reels', 'Stories', 'Explore'],
  color: 6
}, {
  question: 'Where does ^name^ want to travel the most? \ud83c\udf0e',
  options: ['Paris', 'New York', 'Bali', 'Tokyo', 'Tulum'],
  color: 7
}, {
  question: 'How tall is ^name^?',
  options: ['Less than 5\'3ft (160cm)', '5\'4ft (161cm) - 5\'8ft (172cm)', '5\'9ft (173cm) - 5\'11ft (181cm)', '6\'0ft (182cm) and up'],
  color: 0
}, {
  question: 'When is ^name^\'s birthday? \ud83c\udf82',
  options: ['September 9th', 'July 7th', 'March 10th', 'February 24th', 'September 19th'],
  color: 1
}, {
  question: 'What is ^name^\'s favorite song right now? \ud83c\udfa7',
  options: ['Song 1', 'Song 2'],
  color: 2
}, {
  question: 'Does ^name^ believe in ghosts? \ud83d\udc7b',
  options: ['Big time', 'A little', 'Not at all'],
  color: 3
}, {
  question: 'How old is ^name^?',
  options: ['18', '20', '22', '24', '26'],
  color: 4
}, {
  question: 'How many times does ^name^ workout per week? \ud83d\udcaa',
  options: ['Once', '2 to 3 times', 'Four times', 'Every day', 'Never'],
  color: 5
}, {
  question: 'Does ^name^ eat his veggies? \ud83e\udd57',
  options: ['Every bit', 'Barely', 'By no means'],
  color: 6
}, {
  question: 'Which color are ^name^\'s eyes? \ud83d\udc41',
  options: ['Blue', 'Amber', 'Brown', 'Hazel', 'Green'],
  color: 7
}, {
  question: 'Does ^name^ like to nap? \ud83d\ude34',
  options: ['Very much', 'Sometimes', 'Definitely not'],
  color: 0
}, {
  question: 'Which is ^name^\'s natural hair color? \ud83e\udd84',
  options: ['Black', 'Dark brown', 'Light brown', 'Blond', 'Gray', 'Red'],
  color: 2
}, {
  question: 'Does ^name^ sing in the shower? \ud83c\udfa4',
  options: ['All the time', 'Sometimes', 'Never'],
  color: 3
}, {
  question: 'What has been the most fun activity in ^name^\'s life so far? \ud83e\udd2a',
  options: ['Backyard camping', 'Water balloon fighting', 'Hiking', 'Night swimming', 'Ice skating'],
  color: 4
}, {
  question: 'What would ^name^ like to be known for? \ud83c\udfc6',
  options: ['Music', 'Scientific achievements', 'Crazy adventures', 'Unique style', 'Art'],
  color: 5
}, {
  question: 'Which one is ^name^\'s happy place? \ud83c\udf08',
  options: ['Cinema', 'Home', 'The beach', 'Gym', 'School'],
  color: 6
}, {
  question: 'How many pairs of shoes does ^name^ own? \ud83d\udc5f',
  options: ['1 pair', '5 pairs', '10 pairs', '+20 pairs'],
  color: 7
}, {
  question: 'Does ^name^ believe in aliens? \ud83d\udef8',
  options: ['Definitely', 'Possibly', 'Not really'],
  color: 0
}, {
  question: 'How many siblings does ^name^ have?',
  options: ['Only child', '1', '2', '3', '4', '+5'],
  color: 1
}, {
  question: 'If ^name^ were an animal, which one would it be?',
  options: ['Lion \ud83e\udd81', 'Eagle \ud83e\udd85', 'Bear \ud83d\udc3b', 'Dolphin \ud83d\udc2c', 'Shark \ud83e\udd88'],
  color: 2
}, {
  question: 'Which one is ^name^?',
  options: ['Creator', 'Follower'],
  color: 3
}, {
  question: 'Does ^name^ like to cook? \ud83c\udf73',
  options: ['Loves it', 'Sometimes', 'Not at all'],
  color: 4
}, {
  question: 'How many hours per day does ^name^ spend on TikTok? \u231b\ufe0f',
  options: ['None at all', '1 hour', '4 hours', 'Day-and-night'],
  color: 5
}, {
  question: 'Which one is ^name^\'s ultimate dream job? \ud83e\udd29',
  options: ['Doctor', 'YouTuber', 'Astronaut', 'Fashion model', 'TikToker'],
  color: 6
}, {
  question: 'What is ^name^\'s most hated food? \ud83e\udd22',
  options: ['Olives', 'Pickles', 'Sushi', 'Eggplant', 'Avocados'],
  color: 7
}, {
  question: 'What is one thing ^name^ cannot live without? \ud83d\ude35',
  options: ['Wi-Fi', 'Phone', 'Pet', 'Coffee'],
  color: 0
}, {
  question: 'What book has impacted ^name^ the most? \ud83d\udcda',
  options: ['Harry Potter', 'The Hunger Games', 'To Kill a Mockingbird', 'I\'ll Give You the Sun', 'The Fault in Our Stars'],
  color: 1
}, {
  question: 'How many countries has ^name^ been to? \ud83c\udf0e',
  options: ['1', '3', '5', '+10'],
  color: 2
}, {
  question: '\u270d\ufe0f Add your own question',
  options: ['', ''],
  color: 3
}]

export const euQuestionsEnglish = [{
  question: 'Which one is ^name^\'s favorite food?',
  options: ['Pizza \ud83c\udf55', 'Burger \ud83c\udf54', 'Sushi \ud83c\udf63', 'Taco \ud83c\udf2e', 'Ramen \ud83c\udf5c'],
  color: 0
}, {
  question: 'How long was ^name^\'s longest relationship? \ud83d\udc95',
  options: ['A week', 'A month', 'Two years', 'And counting'],
  color: 1
}, {
  question: 'What is one weird talent ^name^ has?',
  options: ['Eyebrow dancing', 'Epic tongue tricks', 'Moving eyes independently', 'Wiggling ears'],
  color: 2
}, {
  question: 'What does ^name^ dislike the most? \ud83d\ude21',
  options: ['Going to the dentist', 'Slow internet', 'Loud phone games', 'Homework'],
  color: 3
}, {
  question: 'If ^name^ could have one superpower, which would it be?',
  options: ['Flight', 'Invisibility', 'Teleportation', 'Telepathy', 'Super speed'],
  color: 4
}, {
  question: 'Which celeb would ^name^ like as a sibling?',
  options: ['Zendaya', 'Billie Eilish', 'Lil Nas X', 'Dua Lipa', 'Justin Bieber'],
  color: 5
}, {
  question: 'Where does ^name^ spend the most time? \ud83d\udcf1',
  options: ['FYP (For you page)', 'Feed', 'Reels', 'Stories', 'Explore'],
  color: 6
}, {
  question: 'Where does ^name^ want to travel the most? \ud83c\udf0e',
  options: ['Paris', 'New York', 'Bali', 'Tokyo', 'Tulum'],
  color: 7
}, {
  question: 'How tall is ^name^?',
  options: ['Less than 5\'3ft (160cm)', '5\'4ft (161cm) - 5\'8ft (172cm)', '5\'9ft (173cm) - 5\'11ft (181cm)', '6\'0ft (182cm) and up'],
  color: 0
}, {
  question: 'When is ^name^\'s birthday? \ud83c\udf82',
  options: ['September 9th', 'July 7th', 'March 10th', 'February 24th', 'September 19th'],
  color: 1
}, {
  question: 'What is ^name^\'s favorite song right now? \ud83c\udfa7',
  options: ['Song 1', 'Song 2'],
  color: 2
}, {
  question: 'Does ^name^ believe in ghosts? \ud83d\udc7b',
  options: ['Big time', 'A little', 'Not at all'],
  color: 3
}, {
  question: 'How old is ^name^?',
  options: ['18', '20', '22', '24', '26'],
  color: 4
}, {
  question: 'How many times does ^name^ workout per week? \ud83d\udcaa',
  options: ['Once', '2 to 3 times', 'Four times', 'Every day', 'Never'],
  color: 5
}, {
  question: 'Does ^name^ eat his veggies? \ud83e\udd57',
  options: ['Every bit', 'Barely', 'By no means'],
  color: 6
}, {
  question: 'Which color are ^name^\'s eyes? \ud83d\udc41',
  options: ['Blue', 'Amber', 'Brown', 'Hazel', 'Green'],
  color: 7
}, {
  question: 'Does ^name^ like to nap? \ud83d\ude34',
  options: ['Very much', 'Sometimes', 'Definitely not'],
  color: 0
}, {
  question: 'Which is ^name^\'s natural hair color? \ud83e\udd84',
  options: ['Black', 'Dark brown', 'Light brown', 'Blond', 'Gray', 'Red'],
  color: 2
}, {
  question: 'Does ^name^ sing in the shower? \ud83c\udfa4',
  options: ['All the time', 'Sometimes', 'Never'],
  color: 3
}, {
  question: 'What has been the most fun activity in ^name^\'s life so far? \ud83e\udd2a',
  options: ['Backyard camping', 'Water balloon fighting', 'Hiking', 'Night swimming', 'Ice skating'],
  color: 4
}, {
  question: 'What would ^name^ like to be known for? \ud83c\udfc6',
  options: ['Music', 'Scientific achievements', 'Crazy adventures', 'Unique style', 'Art'],
  color: 5
}, {
  question: 'Which one is ^name^\'s happy place? \ud83c\udf08',
  options: ['Cinema', 'Home', 'The beach', 'Gym', 'School'],
  color: 6
}, {
  question: 'How many pairs of shoes does ^name^ own? \ud83d\udc5f',
  options: ['1 pair', '5 pairs', '10 pairs', '+20 pairs'],
  color: 7
}, {
  question: 'Does ^name^ believe in aliens? \ud83d\udef8',
  options: ['Definitely', 'Possibly', 'Not really'],
  color: 0
}, {
  question: 'How many siblings does ^name^ have?',
  options: ['Only child', '1', '2', '3', '4', '+5'],
  color: 1
}, {
  question: 'If ^name^ were an animal, which one would it be?',
  options: ['Lion \ud83e\udd81', 'Eagle \ud83e\udd85', 'Bear \ud83d\udc3b', 'Dolphin \ud83d\udc2c', 'Shark \ud83e\udd88'],
  color: 2
}, {
  question: 'Which one is ^name^?',
  options: ['Creator', 'Follower'],
  color: 3
}, {
  question: 'Does ^name^ like to cook? \ud83c\udf73',
  options: ['Loves it', 'Sometimes', 'Not at all'],
  color: 4
}, {
  question: 'How many hours per day does ^name^ spend on TikTok? \u231b\ufe0f',
  options: ['None at all', '1 hour', '4 hours', 'Day-and-night'],
  color: 5
}, {
  question: 'Which one is ^name^\'s ultimate dream job? \ud83e\udd29',
  options: ['Doctor', 'YouTuber', 'Astronaut', 'Fashion model', 'TikToker'],
  color: 6
}, {
  question: 'What is ^name^\'s most hated food? \ud83e\udd22',
  options: ['Olives', 'Pickles', 'Sushi', 'Eggplant', 'Avocados'],
  color: 7
}, {
  question: 'What is one thing ^name^ cannot live without? \ud83d\ude35',
  options: ['Wi-Fi', 'Phone', 'Pet', 'Coffee'],
  color: 0
}, {
  question: 'What book has impacted ^name^ the most? \ud83d\udcda',
  options: ['Harry Potter', 'The Hunger Games', 'To Kill a Mockingbird', 'I\'ll Give You the Sun', 'The Fault in Our Stars'],
  color: 1
}, {
  question: 'How many countries has ^name^ been to? \ud83c\udf0e',
  options: ['1', '3', '5', '+10'],
  color: 2
}, {
  question: '\u270d\ufe0f Add your own question',
  options: ['', ''],
  color: 3
}]

export const euQuestionsSpanish = [{
  question: '¿Cual es la comida favorita de ^name^?',
  options: ['Pizza \ud83c\udf55', 'Hamburguesa \ud83c\udf54', 'Sushi \ud83c\udf63', 'Taco \ud83c\udf2e', 'Ramen \ud83c\udf5c'],
  color: 0
}, {
  question: '¿Cuanto tiempo duro la relacion mas larga de ^name^? \ud83d\udc95',
  options: ['Una semana', 'Un mes', 'Dos a\u00f1os', 'Y contando'],
  color: 1
}, {
  question: '¿Que talento extra\u00f1o tiene ^name^?',
  options: ['Trucos con las cejas', 'Trucos con la lengua', 'Ojos locos', 'Mueve sus orejas'],
  color: 2
}, {
  question: '¿Que es lo que menos le gusta a ^name^? \ud83d\ude21',
  options: ['Ir al dentista', 'Internet lento', 'Juegos mobiles ruidosos', 'Hacer tareas'],
  color: 3
}, {
  question: '¿Que superpoder elegiria ^name^?',
  options: ['Volar', 'Invisibilidad', 'Teletransportarse', 'Telepatia', 'Super velocidad'],
  color: 4
}, {
  question: '¿Que celebridad le gustaria a ^name^ como herman@?',
  options: ['Zendaya', 'Billie Eilish', 'Lil Nas X', 'Dua Lipa', 'Justin Bieber'],
  color: 5
}, {
  question: '¿De que color son los ojos de ^name^? \ud83d\udc41',
  options: ['Azul', 'Ambar', 'Marron', 'Avellana', 'Verde'],
  color: 6
}, {
  question: '¿A donde le gustaria mas viajar a ^name^? \ud83c\udf0e',
  options: ['Paris', 'New York', 'Bali', 'Tokio', 'Tulum'],
  color: 7
}, {
  question: '¿Cuanto mide ^name^?',
  options: ['Menos de 1.60m', '1.61m - 1.72m', '1.73m - 1.81m', 'Mas de 1.82m'],
  color: 0
}, {
  question: '¿Cuando cumple a\u00f1os ^name^? \ud83c\udf82',
  options: ['9 de Septiembre', '7 de Julio', '10 de Marzo', '24 de Febrero', '19 de Septiembre'],
  color: 1
}, {
  question: '¿Cual es la cancion favorita de ^name^ actualmente? \ud83c\udfa7',
  options: ['Cancion 1', 'Cancion 2'],
  color: 2
}, {
  question: '¿^name^ cree en fantasmas? \ud83d\udc7b',
  options: ['Si', 'Tal vez', 'Para nada'],
  color: 3
}, {
  question: '¿Que edad tiene ^name^?',
  options: ['18', '20', '22', '24', '26'],
  color: 4
}, {
  question: '¿Cuantas veces a la semana entrena ^name^? \ud83d\udcaa',
  options: ['Solo una', '2 o 3 veces', 'Cuatro veces', 'Todos los dias', 'Nunca'],
  color: 5
}, {
  question: '¿^name^ come sus vegetales? \ud83e\udd57',
  options: ['Hasta el ultimo bocado', 'Solo un poco', 'De ninguna manera'],
  color: 6
}, {
  question: '¿Donde pasa ^name^ la mayor parte del tiempo? \ud83d\udcf1',
  options: ['Para ti (TikTok)', 'Feed (Instagram)', 'Reels', 'Historias', 'Tendencias'],
  color: 7
}, {
  question: '¿A ^name^ le gusta tomar siestas? \ud83d\ude34',
  options: ['Muchisimo', 'A veces', 'No'],
  color: 0
}, {
  question: '¿Cual es el color natural del cabello de ^name^? \ud83e\udd84',
  options: ['Negro', 'Marron oscuro', 'Marron claro', 'Rubio', 'Gris', 'Rojo'],
  color: 2
}, {
  question: '¿^name^ canta en la ducha? \ud83c\udfa4',
  options: ['Siempre', 'A veces', 'Nunca'],
  color: 3
}, {
  question: '¿Cual ha sido la actividad mas divertida para ^name^? \ud83e\udd2a',
  options: ['Camping en el patio trasero', 'Pelea de globos de agua', 'Senderismo', 'Nadar de noche', 'Ice skating'],
  color: 4
}, {
  question: '¿Por que le gustaria ser famoso a ^name^? \ud83c\udfc6',
  options: ['Musica', 'Logros cientificos', 'Locas aventuras', 'Estilo unico', 'Arte'],
  color: 5
}, {
  question: '¿Cual de estos es el lugar feliz de ^name^? \ud83c\udf08',
  options: ['Cine', 'Casa', 'La playa', 'Gimnasio', 'Escuela'],
  color: 6
}, {
  question: '¿Cuantos pares de zapatos tiene ^name^? \ud83d\udc5f',
  options: ['1 par', '5 pares', '10 pares', '+20 pares'],
  color: 7
}, {
  question: '¿^name^ cree en los extraterrestres? \ud83d\udef8',
  options: ['Muchisimo', 'Quizas', 'Para nada'],
  color: 0
}, {
  question: '¿Cuantos herman@s tiene ^name^?',
  options: ['Hijo unico', '1', '2', '3', '4', '+5'],
  color: 1
}, {
  question: 'Si ^name^ pudiera ser un animal, ¿cual seria?',
  options: ['Leon \ud83e\udd81', 'Aguila \ud83e\udd85', 'Oso \ud83d\udc3b', 'Delfin \ud83d\udc2c', 'Tiburon \ud83e\udd88'],
  color: 2
}, {
  question: '¿Cual es ^name^?',
  options: ['Creador', 'Seguidor'],
  color: 3
}, {
  question: '¿A ^name^ le gusta cocinar? \ud83c\udf73',
  options: ['Le encanta', 'A veces', 'Para nada'],
  color: 4
}, {
  question: '¿Cuantas horas al día pasa ^name^ en TikTok? \u231b\ufe0f',
  options: ['Ninguna', '1 hora', '4 horas', 'Dia y noche'],
  color: 5
}, {
  question: '¿Cual es el trabajo so\u00f1ado de ^name^? \ud83e\udd29',
  options: ['Doctor', 'YouTuber', 'Astronauta', 'Modelo', 'TikToker'],
  color: 6
}, {
  question: '¿Cual es la comida que mas odia ^name^? \ud83e\udd22',
  options: ['Aceitunas', 'Pepinillos', 'Sushi', 'Berenjenas', 'Aguacates'],
  color: 7
}, {
  question: '¿Que es algo sin lo que ^name^ no puede vivir? \ud83d\ude35',
  options: ['Wi-Fi', 'Celular', 'Mascota', 'Cafe'],
  color: 0
}, {
  question: '¿Que libro ha impactado mas a ^name^? \ud83d\udcda',
  options: ['Harry Potter', 'Los Juegos del Hambre', 'Matar a un Ruise\u00f1or', 'Te Daria el Sol', 'Bajo la Misma Estrella'],
  color: 1
}, {
  question: '¿En cuantos paises ha estado ^name^? \ud83c\udf0e',
  options: ['1', '3', '5', '+10'],
  color: 2
}, {
  question: '\u270d\ufe0f Agrega tu propia pregunta',
  options: ['', ''],
  color: 3
}]

export const euQuestionsNorwegian = [{
  question: '\ud83d\udcc5 Når er bursdagen til ^name^?',
  options: ['10. januar', '23. september', '3. oktober', '27. desember'],
  color: 0
}, {
  question: '^name^ har aldri noen gang...',
  options: ['\ud83d\ude37 Knust et bein', '\ud83d\udebd Droppet mobilen på toalettet', '\ud83d\ude34 Holdt oppe i mer enn 24 timer', '\ud83c\udf55 Spiste en hel pizza av seg selv'],
  color: 1
}, {
  question: '\ud83d\udc6a Hvor mange søsken har ^name^?',
  options: ['Ingen', '5', '2', '1'],
  color: 2
}, {
  question: '\ud83c\udf6d Hvis ^name^ kunne våkne opp med en helt annen permanent hårfarge, hva ville det da være?',
  options: ['Rosa', 'Blå', 'Purple', 'Grønn', 'Rød'],
  color: 3
}, {
  question: 'Er ^name^ singel eller tatt? \ud83d\udc91',
  options: ['Enkelt', 'Tatt'],
  color: 4
}, {
  question: '\ud83c\udf7f Hva er ^name^s favorittserie på Netflix?',
  options: ['Stranger Things', 'Friends', '13 Reasons Why', 'Narcos'],
  color: 5
}, {
  question: '\ud83d\udcb0 Hvis ^name^ har en time å bruke 1 million \ud83d\udcb2, hvor tror du at han/hun vil gå først til?',
  options: ['\ud83d\udecd\ufe0f En designerbutikk', '\ud83c\udf63 En luksuriøs restaurant', '\ud83d\ude97 Et luksusbilforhandler'],
  color: 6
}, {
  question: '\ud83d\udc6a Hvor mange barn vil ^name^ ha?',
  options: ['10', '3', '2', '1', 'Ingen'],
  color: 7
}, {
  question: '\u2708\ufe0f Hvis ^name^ kunne dra hvor som helst, ville det være ...',
  options: ['Paris', 'Hawaii', 'New York', 'Tokio'],
  color: 0
}, {
  question: '\ud83c\udf68 Hva er ^name^s favoritt iskremsmak?',
  options: ['Vanilje', 'Sjokolade', 'Kjeksdeig', 'Jordbær', 'Mint Sjokolade Chip'],
  color: 1
}, {
  question: 'Hvis ^name^ kan være et dyr i en dag, hvilken ville det da være?',
  options: ['\ud83d\udc2c Delfin', '\ud83d\udc07 Kanin', '\ud83e\udd88 Hai', '\ud83d\udc3c Panda bjørn'],
  color: 2
}, {
  question: 'Hvis ^name^ måtte spise den samme maten til middag hver dag, hva ville han da valgt?',
  options: ['\ud83c\udf54 Burger', '\ud83c\udf63 Sushi', '\ud83c\udf55 Pizza', '\ud83c\udf2f Burrito'],
  color: 3
}, {
  question: '\ud83c\udfa5 Hva er ^name^s favoritt YouTuber?',
  options: ['David Dobrik', 'emma chamberlain', 'The ACE Family', 'Shane Dawson'],
  color: 4
}, {
  question: '\ud83c\udf81 Hva er den beste gaven ^name^ har fått?',
  options: ['\ud83d\udc08 Et kjæledyr', '\ud83d\ude18 Et kyss', '\u2708\ufe0f En overraskelse reise', '\ud83d\udcf1 En telefon'],
  color: 5
}, {
  question: 'Hva er ^name^s favorittidrett?',
  options: ['\u26bd Fotball', '\ud83c\udfc2 Snowboard', '\ud83c\udfc0 Basketball', '\ud83c\udfd0 Volleyball'],
  color: 6
}, {
  question: '\ud83d\udc75 Hvor gammel er ^name^? \ud83d\udc74',
  options: ['15', '21', '30', '32'],
  color: 7
}, {
  question: 'Hvis ^name^ øyeblikkelig kunne snakke flytende noe annet språk, hva ville da det språket vært?',
  options: ['\ud83c\uddeb\ud83c\uddf7 Fransk', '\ud83c\udde9\ud83c\uddea Tysk', '\ud83c\uddef\ud83c\uddf5 Japansk', '\ud83c\uddee\ud83c\uddf9 Italiensk'],
  color: 0
}, {
  question: '\ud83d\ude31 Hva er ^name^ mest redd for?',
  options: ['\ud83d\udc1b Bugs', '\ud83d\udd77\ufe0f Edderkopper', '\ud83d\udc00 Rotter og mus'],
  color: 1
}, {
  question: '\ud83d\udcdb Hva heter ^name^s mellomnavn?',
  options: ['James', 'Louise', 'Lee', 'Anne/Ann'],
  color: 2
}, {
  question: '\ud83d\uddef\ufe0f Hvis ^name^ kunne være tegneseriefigurer for en dag, hvem ville det da være?',
  options: ['Rick (Rick & Morty)', 'Phineas/Ferb', 'Gumball', 'Finn/Jake/Bubblegum (Adventure Time)'],
  color: 3
}, {
  question: 'Hvem er ^name^s favoritt, mamma eller pappa?',
  options: ['\ud83d\udc69 Mamma', '\ud83d\udc68 Pappa'],
  color: 4
}, {
  question: 'Hva er ^name^s drømmejobb?',
  options: ['\ud83d\udc68\u200d\ud83d\ude80 Astronaut', '\ud83c\udfa5 Berømt skuespiller/skuespillerinne', '\ud83c\udf0c Jedi', '\ud83d\udd2c Forsker'],
  color: 5
}, {
  question: '\ud83c\udfac Hva er ^name^s favorittfilm fra 2019 så langt?',
  options: ['Avengers: Endgame', 'It: Chapter Two', 'Toy Story 4', 'Spider-Man: Far From Home'],
  color: 6
}, {
  question: 'Hva ville ^name^ heller vunnet?',
  options: ['\ud83c\udfc6 Nobels fredspris', '\ud83d\udcfd\ufe0f En Oscar-utdeling', '\ud83c\udfc5 En OL-medalje'],
  color: 7
}, {
  question: '\ud83d\udcfa Hva er ^name^s favoritt TV-show?',
  options: ['The Office', 'Lost', 'Breaking Bad', 'FRIENDS', 'Game of Thrones'],
  color: 0
}, {
  question: '\ud83c\udf08 Hva er ^name^s favorittfarge?',
  options: ['Rosa', 'Blå', 'Purple', 'Rød', 'Grønn'],
  color: 1
}, {
  question: '\ud83c\udf92 Hvor mange skoler har ^name^ gått?',
  options: ['6', '1', '2', '5'],
  color: 2
}, {
  question: '\u270d\ufe0f Legg til ditt eget spørsmål',
  options: ['', ''],
  color: 3
}]

export const euQuestionsFrench = [{
  question: '\ud83d\udcc5 Quand est l\'anniversaire d\'^name^?',
  options: ['10 janvier', '23 septembre', '3 octobre', '27 décembre'],
  color: 0
}, {
  question: '^name^ n\'a jamais ...',
  options: ['\ud83d\ude37 Cassé un os', '\ud83d\udebd Laissé tomber le téléphone dans les toilettes', '\ud83d\ude34 Resté éveillé plus de 24 heures', '\ud83c\udf55 Mangé toute une pizza toute seule'],
  color: 1
}, {
  question: '\ud83d\udc6a Combien de frères et sœurs ^name^ a-t-il?',
  options: ['Aucun', '5', '2', '1'],
  color: 2
}, {
  question: '\ud83c\udf6d Si ^name^ pouvait se réveiller avec une couleur de cheveux permanente complètement différente, ce serait quoi?',
  options: ['Rose', 'Bleu', 'Violet', 'Vert', 'Rouge'],
  color: 3
}, {
  question: '^name^ est-il célibataire ou pris/prise? \ud83d\udc91',
  options: ['Célibataire', 'Pris/Prise'],
  color: 4
}, {
  question: '\ud83c\udf7f Quelle est la série préférée d\'^name^ sur Netflix?',
  options: ['Stranger Things', 'Friends', '13 Reasons Why', 'Narcos'],
  color: 5
}, {
  question: '\ud83d\udcb0 Si ^name^ a une heure pour dépenser 1 million \ud83d\udcb2, où pensez-vous qu\'il / elle irait en premier?',
  options: ['\ud83d\udecd\ufe0f Un magasin de créateurs', '\ud83c\udf63 Un restaurant de luxe', '\ud83d\ude97 Un concessionnaire de voitures de luxe'],
  color: 6
}, {
  question: '\ud83d\udc6a Combien d\'enfants ^name^ aura-t-il?',
  options: ['10', '3', '2', '1', 'Aucun'],
  color: 7
}, {
  question: '\u2708\ufe0f Si ^name^ pouvait aller n\'importe où, ce serait ...',
  options: ['Paris', 'Hawaii', 'New York', 'Tokio'],
  color: 0
}, {
  question: '\ud83c\udf68 Quelle est la saveur de crème glacée préférée d\'^name^?',
  options: ['Vanille', 'Chocolat', 'Pâte à biscuits', 'Fraise', 'Pépites de chocolat à la menthe'],
  color: 1
}, {
  question: 'Si ^name^ pouvait être un animal pendant une journée, lequel serait-il?',
  options: ['\ud83d\udc2c Dauphin', '\ud83d\udc07 Lapin', '\ud83e\udd88 Requin', '\ud83d\udc3c Panda'],
  color: 2
}, {
  question: 'Si ^name^ devait manger la même nourriture pour le dîner tous les jours, que choisirait-il?',
  options: ['\ud83c\udf54 Burger', '\ud83c\udf63 Sushi', '\ud83c\udf55 Pizza', '\ud83c\udf2f Burrito'],
  color: 3
}, {
  question: '\ud83c\udfa5 Quel est le YouTuber préféré d\'^name^?',
  options: ['David Dobrik', 'emma chamberlain', 'The ACE Family', 'Shane Dawson'],
  color: 4
}, {
  question: '\ud83c\udf81 Quel est le meilleur cadeau que ^name^ a reçu?',
  options: ['\ud83d\udc08 Un animal de compagnie', '\ud83d\ude18 Un baiser de son béguin', '\u2708\ufe0f Un voyage surprise', '\ud83d\udcf1 Un téléphone'],
  color: 5
}, {
  question: 'Quel est le sport préféré d\'^name^?',
  options: ['\u26bd Football', '\ud83d\udeb4 Cycling', '\ud83c\udfc9 Rugby', '\ud83c\udfbe Tennis'],
  color: 6
}, {
  question: '\ud83d\udc75 Quel âge a ^name^? \ud83d\udc74',
  options: ['15', '21', '30', '32'],
  color: 7
}, {
  question: 'Si ^name^ pouvait instantanément parler couramment une autre langue, quelle serait cette langue?',
  options: ['\ud83c\uddea\ud83c\uddf8 Espagnol', '\ud83c\udde9\ud83c\uddea Allemand', '\ud83c\uddef\ud83c\uddf5 Japonais', '\ud83c\uddee\ud83c\uddf9 Italien'],
  color: 0
}, {
  question: '\ud83d\ude31 De quoi ^name^ à-t-il le plus peur?',
  options: ['\ud83d\udc1b Bogues', '\ud83d\udd77\ufe0f Les araignées', '\ud83d\udc00 Rats et souris'],
  color: 1
}, {
  question: '\ud83d\udcdb Quel est le deuxième prénom d\'^name^?',
  options: ['James', 'Louise', 'Lee', 'Anne/Ann'],
  color: 2
}, {
  question: '\ud83d\uddef\ufe0f Si ^name^ pouvait être un personnage de dessin animé pendant un jour, ce serait qui?',
  options: ['Rick (Rick & Morty)', 'Phineas/Ferb', 'Gumball', 'Finn/Jake/Bubblegum (Adventure Time)'],
  color: 3
}, {
  question: 'Qui est le préféré d\'^name^, maman ou papa?',
  options: ['\ud83d\udc69 Maman', '\ud83d\udc68 Papa'],
  color: 4
}, {
  question: 'Quel est le métier de rêve d\'^name^?',
  options: ['\ud83d\udc68\u200d\ud83d\ude80 Astronaute', '\ud83c\udfa5 Célèbre acteur/actrice', '\ud83c\udf0c Jedi', '\ud83d\udd2c Scientifique'],
  color: 5
}, {
  question: '\ud83c\udfac Quel est le film préféré d\'^name^ en 2019 jusqu\'à présent?',
  options: ['Avengers: Endgame', 'It: Chapter Two', 'Toy Story 4', 'Spider-Man: Far From Home'],
  color: 6
}, {
  question: 'Qu\'est-ce que ^name^ préférerait gagner?',
  options: ['\ud83c\udfc6 Le prix nobel de la Paix', '\ud83d\udcfd\ufe0f Un Academy Award', '\ud83c\udfc5 Une médaille olympique'],
  color: 7
}, {
  question: '\ud83d\udcfa Quelle est l\'émission de télévision préférée d\'^name^?',
  options: ['The Office', 'Lost', 'Breaking Bad', 'FRIENDS', 'Game of Thrones'],
  color: 0
}, {
  question: '\ud83c\udf08 Quelle est la couleur préférée d\'^name^?',
  options: ['Rose', 'Bleu', 'Violet', 'Rouge', 'Vert'],
  color: 1
}, {
  question: '\ud83c\udf92 À combien d\'écoles ^name^ est-il allé?',
  options: ['6', '1', '2', '5'],
  color: 2
}, {
  question: '\u270d\ufe0f Ajoutez votre propre question',
  options: ['', ''],
  color: 3
}]

export const euQuestionsPortuguese = [{
  question: '\ud83d\udcc5 Quando é o aniversário de ^name^?',
  options: ['10 de janeiro', '23 de setembro', '3 de outubro', '27 de dezembro'],
  color: 0
}, {
  question: '^name^ nunca...',
  options: ['\ud83d\ude37 Um osso foi quebrado', '\ud83d\udebd Ele largou o celular no banheiro', '\ud83d\ude34 Ela ficou acordad@ por mais de 24 horas', '\ud83c\udf55 Ele comeu uma pizza inteira'],
  color: 1
}, {
  question: '\ud83d\udc6a ¿Quant@s irmãos/irmãs você tem ^name^?',
  options: ['Nenhuma', '5', '2', '1'],
  color: 2
}, {
  question: '\ud83c\udf6d Se ^name^ tivesse que escolher uma nova cor de cabelo (para sempre), que cor ele escolheria?',
  options: ['Rose', 'Azul', 'Roxo', 'Verde', 'Vermelho'],
  color: 3
}, {
  question: '^name^ está solteiro ou com um parceiro? \ud83d\udc91',
  options: ['Solteiro', 'Com parceiro'],
  color: 4
}, {
  question: '\ud83c\udf7f Qual é a série favorita de ^name^ na Netflix?',
  options: ['Stranger Things', 'Friends', '13 Reasons Why', 'Narcos'],
  color: 5
}, {
  question: '\ud83d\udcb0 Se ^name^ tivesse uma hora para gastar 1 milhão \ud83d\udcb2, para onde ele/ela iria?',
  options: ['\ud83d\udecd\ufe0f Uma loja de grife', '\ud83c\udf63 Para um restaurante', '\ud83d\ude97 Para uma concessionária de carros'],
  color: 6
}, {
  question: '\ud83d\udc6a ¿Quantos filhos ^name^ gostaria de ter?',
  options: ['10', '3', '2', '1', 'Nenhuma'],
  color: 7
}, {
  question: '\u2708\ufe0f Se ^name^ pudesse ir a qualquer lugar, para onde ele iria?',
  options: ['Paris', 'Havaí', 'Nova York', 'Tokio'],
  color: 0
}, {
  question: '\ud83c\udf68 Qual é o sabor favorito de sorvete de ^name^?',
  options: ['Baunilha', 'Chocolate', 'Amêndoa', 'Morango', 'Creme de Chocolate'],
  color: 1
}, {
  question: 'Que animal ^name^ gostaria de ser por um dia?',
  options: ['\ud83d\udc2c Golfinho', '\ud83d\udc07 Coelho', '\ud83e\udd88 Tubarão', '\ud83d\udc3c Urso panda'],
  color: 2
}, {
  question: 'Se ^name^ tivesse que comer o mesmo prato todos os dias, que comida seria?',
  options: ['\ud83c\udf54 Hamburger', '\ud83c\udf63 Sushi', '\ud83c\udf55 Pizza', '\ud83c\udf2f Burrito'],
  color: 3
}, {
  question: '\ud83c\udfa5 Qual é o YouTuber favorito de ^name^?',
  options: ['David Dobrik', 'emma chamberlain', 'The ACE Family', 'Shane Dawson'],
  color: 4
}, {
  question: '\ud83c\udf81 Qual é o melhor presente que ^name^ recebeu?',
  options: ['\ud83d\udc08 Um mascote', '\ud83d\ude18 Um beijo de sua paixão', '\u2708\ufe0f Uma viagem surpresa'],
  color: 5
}, {
  question: 'Qual é o esporte favorito de ^name^?',
  options: ['\u26bd Futebol', '\ud83c\udfc8 Jiu Jitsu', '\ud83c\udfc0 Basquetebol', '\ud83c\udfd0 Vôlei'],
  color: 6
}, {
  question: '\ud83d\udc75 Quantos anos ^name^ tem? \ud83d\udc74',
  options: ['15', '21', '30', '32'],
  color: 7
}, {
  question: 'Se ^name^ pudesse aprender instantaneamente um novo idioma, qual idioma ele/ela escolheria?',
  options: ['\ud83c\uddeb\ud83c\uddf7 Frances', '\ud83c\udde9\ud83c\uddea Alemão', '\ud83c\uddef\ud83c\uddf5 Japonês', '\ud83c\uddee\ud83c\uddf9 Italiano'],
  color: 0
}, {
  question: '\ud83d\ude31 Qual é o maior medo de ^name^?',
  options: ['\ud83d\udc1b Insetos', '\ud83d\udd77\ufe0f Aranhas', '\ud83d\udc00 Ratos e ratos'],
  color: 1
}, {
  question: '\ud83d\udcdb Qual é o nome do meio de ^name^?',
  options: ['James', 'Louise', 'Lee', 'Anne/Ann'],
  color: 2
}, {
  question: '\ud83d\uddef\ufe0f Se ^name^ pudesse ser um personagem de desenho animado por um dia, qual seria?',
  options: ['Rick (Rick & Morty)', 'Phineas/Ferb', 'Gumball', 'Finn/Jake/Bubblegum (Adventure Time)'],
  color: 3
}, {
  question: 'Quem é o favorito de ^name^, Mama ou Papa?',
  options: ['\ud83d\udc69 Mama', '\ud83d\udc68 Papa'],
  color: 4
}, {
  question: 'Qual é o emprego dos sonhos de ^name^?',
  options: ['\ud83d\udc68\u200d\ud83d\ude80 Astronauta', '\ud83c\udfa5 Ator/actriz famoso', '\ud83c\udf0c Jedi', '\ud83d\udd2c Cientista'],
  color: 5
}, {
  question: '\ud83c\udfac Qual é o filme favorito de ^name^ em 2019?',
  options: ['Avengers: Endgame', 'It: Chapter Two', 'Toy Story 4', 'Spider-Man: Far From Home'],
  color: 6
}, {
  question: 'Qual dos seguintes prêmios ^name^ prefere ganhar?',
  options: ['\ud83c\udfc6 Premio Nobel da Paz', '\ud83d\udcfd\ufe0f Prémio Oscar', '\ud83c\udfc5 Medalha Olímpica'],
  color: 7
}, {
  question: '\ud83d\udcfa Qual é a série de TV favorita de ^name^?',
  options: ['The Office', 'Lost', 'Breaking Bad', 'Friends', 'Game of Thrones'],
  color: 0
}, {
  question: '\ud83c\udf08 Qual é a cor favorita de ^name^?',
  options: ['Rose', 'Azul', 'Roxo', 'Vermelho', 'Verde'],
  color: 1
}, {
  question: '\ud83c\udf92 Quantas escolas ^name^ frequentou?',
  options: ['6', '1', '2', '5'],
  color: 2
}, {
  question: '\u270d\ufe0f Adicione sua própria pergunta',
  options: ['', ''],
  color: 3
}]

export const euQuestionsItaliano = [{
  question: '\ud83d\udcc5 Quando è il compleanno di ^name^?',
  options: ['10 gennaio', '23 settembre', '3 ottobre', '27 dicembre'],
  color: 0
}, {
  question: '^name^ non ha mai...',
  options: ['\ud83d\ude37 Rotto un osso', '\ud83d\udebd Lasciò cadere il cellulare nel gabinetto', '\ud83d\ude34 Stati svegli per più di 24 ore', '\ud83c\udf55 Ha mangiato una pizza intera da sol@'],
  color: 1
}, {
  question: '\ud83d\udc6a Quanti fratelli ha ^name^?',
  options: ['Nessuna', '5', '2', '1'],
  color: 2
}, {
  question: '\ud83c\udf6d Se ^name^ potesse svegliarsi con un colore di capelli permanente completamente diverso, quale sarebbe?',
  options: ['Rosa', 'Blu', 'Viola', 'Verde', 'Rosso'],
  color: 3
}, {
  question: '^name^ è single o preso? \ud83d\udc91',
  options: ['Single', 'Preso'],
  color: 4
}, {
  question: '\ud83c\udf7f Qual è la serie preferita di ^name^ su Netflix?',
  options: ['Stranger Things', 'Friends', '13 Reasons Why', 'Narcos'],
  color: 5
}, {
  question: '\ud83d\udcb0 Se ^name^ ha un\'ora da spendere 1 milione \ud83d\udcb2, dove pensi che andrebbe per primo?',
  options: ['\ud83d\udecd\ufe0f Un negozio di design', '\ud83c\udf63 Un ristorante di lusso', '\ud83d\ude97 Una concessionaria di auto di lusso'],
  color: 6
}, {
  question: '\ud83d\udc6a Quanti bambini avranno ^name^?',
  options: ['10', '3', '2', '1', 'Nessuna'],
  color: 7
}, {
  question: '\u2708\ufe0f Se ^name^ potesse andare ovunque, sarebbe...',
  options: ['Parigi', 'Hawaii', 'New York', 'Tokio'],
  color: 0
}, {
  question: '\ud83c\udf68 Qual è il gusto di gelato preferito di ^name^?',
  options: ['Vaniglia', 'Cioccolato', 'Pasta biscotto', 'Fragola', 'Gocce di cioccolato alla menta'],
  color: 1
}, {
  question: 'Se ^name^ potesse essere un animale per un giorno, quale sarebbe?',
  options: ['\ud83d\udc2c Delfino', '\ud83d\udc07 Coniglio', '\ud83e\udd88 Squalo', '\ud83d\udc3c Panda'],
  color: 2
}, {
  question: 'Se ^name^ dovesse mangiare lo stesso cibo per cena ogni giorno, cosa sceglierebbe?',
  options: ['\ud83c\udf54 Burger', '\ud83c\udf63 Sushi', '\ud83c\udf55 Pizza', '\ud83c\udf2f Burrito'],
  color: 3
}, {
  question: '\ud83c\udfa5 Qual è il YouTuber preferito di ^name^?',
  options: ['David Dobrik', 'emma chamberlain', 'PewDiePie', 'Shane Dawson'],
  color: 4
}, {
  question: '\ud83c\udf81 Qual è il miglior regalo che ^name^ ha ricevuto?',
  options: ['\ud83d\udc08 Un animale domestico', '\ud83d\ude18 Un bacio dalla sua cotta', '\u2708\ufe0f Un viaggio a sorpresa', '\ud83d\udcf1 Un telefono'],
  color: 5
}, {
  question: 'Qual è lo sport preferito di ^name^?',
  options: ['\u26bd Calcio', '\ud83d\udeb4 Ciclismo', '\ud83c\udfc0 Pallacanestro', '\u26f7\ufe0f Sciare'],
  color: 6
}, {
  question: '\ud83d\udc75 Quanti anni ha ^name^? \ud83d\udc74',
  options: ['15', '21', '30', '32'],
  color: 7
}, {
  question: 'Se ^name^ fosse in grado di parlare istantaneamente qualsiasi altra lingua, quale sarebbe quella lingua?',
  options: ['\ud83c\uddeb\ud83c\uddf7 Francese', '\ud83c\udde9\ud83c\uddea Tedesco', '\ud83c\uddef\ud83c\uddf5 Giapponese', '\ud83c\uddea\ud83c\uddf8 Spagnolo'],
  color: 0
}, {
  question: '\ud83d\ude31 Di cosa ha più paura ^name^?',
  options: ['\ud83d\udc1b Bugs', '\ud83d\udd77\ufe0f Ragni', '\ud83d\udc00 Ratti e topi'],
  color: 1
}, {
  question: '\ud83d\udcdb Qual è il secondo nome di ^name^?',
  options: ['James', 'Louise', 'Lee', 'Anne/Ann'],
  color: 2
}, {
  question: '\ud83d\uddef\ufe0f Se ^name^ potesse essere un personaggio dei cartoni animati per un giorno, chi sarebbe?',
  options: ['Rick (Rick & Morty)', 'Phineas/Ferb', 'Gumball', 'Finn/Jake/Bubblegum (Adventure Time)'],
  color: 3
}, {
  question: 'Chi è il preferito di ^name^, mamma o papà?',
  options: ['\ud83d\udc69 Mamma', '\ud83d\udc68 Papà'],
  color: 4
}, {
  question: 'Qual è il lavoro da sogno di ^name^?',
  options: ['\ud83d\udc68\u200d\ud83d\ude80 Astronauta', '\ud83c\udfa5 Attore/attrice famos@', '\ud83c\udf0c Jedi', '\ud83d\udd2c Scienziat@'],
  color: 5
}, {
  question: '\ud83c\udfac Qual è il film preferito di ^name^ del 2019 finora?',
  options: ['Avengers: Endgame', 'It: Chapter Two', 'Toy Story 4', 'Spider-Man: Far From Home'],
  color: 6
}, {
  question: 'Cosa preferirebbe vincere ^name^?',
  options: ['\ud83c\udfc6 Il premio Nobel per la pace', '\ud83d\udcfd\ufe0f Un premio Oscar', '\ud83c\udfc5 Una medaglia olimpica'],
  color: 7
}, {
  question: '\ud83d\udcfa Qual è il programma TV preferito di ^name^?',
  options: ['The Office', 'Lost', 'Breaking Bad', 'FRIENDS', 'Game of Thrones'],
  color: 0
}, {
  question: '\ud83c\udf08 Qual è il colore preferito di ^name^?',
  options: ['Rosa', 'Blu', 'Viola', 'Rosso', 'Verde'],
  color: 1
}, {
  question: '\ud83c\udf92 Quante scuole ha frequentato ^name^?',
  options: ['6', '1', '2', '5'],
  color: 2
}, {
  question: '\u270d\ufe0f Aggiungi la tua domanda',
  options: ['', ''],
  color: 3
}]

export const asQuestionsEnglish = [{
  question: 'Which one is ^name^\'s favorite food?',
  options: ['Pizza \ud83c\udf55', 'Burger \ud83c\udf54', 'Sushi \ud83c\udf63', 'Taco \ud83c\udf2e', 'Ramen \ud83c\udf5c'],
  color: 0
}, {
  question: 'How long was ^name^\'s longest relationship? \ud83d\udc95',
  options: ['A week', 'A month', 'Two years', 'And counting'],
  color: 1
}, {
  question: 'What is one weird talent ^name^ has?',
  options: ['Eyebrow dancing', 'Epic tongue tricks', 'Moving eyes independently', 'Wiggling ears'],
  color: 2
}, {
  question: 'What does ^name^ dislike the most? \ud83d\ude21',
  options: ['Going to the dentist', 'Slow internet', 'Loud phone games', 'Homework'],
  color: 3
}, {
  question: 'If ^name^ could have one superpower, which would it be?',
  options: ['Flight', 'Invisibility', 'Teleportation', 'Telepathy', 'Super speed'],
  color: 4
}, {
  question: 'Which celeb would ^name^ like as a sibling?',
  options: ['Zendaya', 'Billie Eilish', 'Lil Nas X', 'Dua Lipa', 'Justin Bieber'],
  color: 5
}, {
  question: 'Where does ^name^ spend the most time? \ud83d\udcf1',
  options: ['FYP (For you page)', 'Feed', 'Reels', 'Stories', 'Explore'],
  color: 6
}, {
  question: 'Where does ^name^ want to travel the most? \ud83c\udf0e',
  options: ['Paris', 'New York', 'Bali', 'Tokyo', 'Tulum'],
  color: 7
}, {
  question: 'How tall is ^name^?',
  options: ['Less than 5\'3ft (160cm)', '5\'4ft (161cm) - 5\'8ft (172cm)', '5\'9ft (173cm) - 5\'11ft (181cm)', '6\'0ft (182cm) and up'],
  color: 0
}, {
  question: 'When is ^name^\'s birthday? \ud83c\udf82',
  options: ['September 9th', 'July 7th', 'March 10th', 'February 24th', 'September 19th'],
  color: 1
}, {
  question: 'What is ^name^\'s favorite song right now? \ud83c\udfa7',
  options: ['Song 1', 'Song 2'],
  color: 2
}, {
  question: 'Does ^name^ believe in ghosts? \ud83d\udc7b',
  options: ['Big time', 'A little', 'Not at all'],
  color: 3
}, {
  question: 'How old is ^name^?',
  options: ['18', '20', '22', '24', '26'],
  color: 4
}, {
  question: 'How many times does ^name^ workout per week? \ud83d\udcaa',
  options: ['Once', '2 to 3 times', 'Four times', 'Every day', 'Never'],
  color: 5
}, {
  question: 'Does ^name^ eat his veggies? \ud83e\udd57',
  options: ['Every bit', 'Barely', 'By no means'],
  color: 6
}, {
  question: 'Which color are ^name^\'s eyes? \ud83d\udc41',
  options: ['Blue', 'Amber', 'Brown', 'Hazel', 'Green'],
  color: 7
}, {
  question: 'Does ^name^ like to nap? \ud83d\ude34',
  options: ['Very much', 'Sometimes', 'Definitely not'],
  color: 0
}, {
  question: 'Which is ^name^\'s natural hair color? \ud83e\udd84',
  options: ['Black', 'Dark brown', 'Light brown', 'Blond', 'Gray', 'Red'],
  color: 2
}, {
  question: 'Does ^name^ sing in the shower? \ud83c\udfa4',
  options: ['All the time', 'Sometimes', 'Never'],
  color: 3
}, {
  question: 'What has been the most fun activity in ^name^\'s life so far? \ud83e\udd2a',
  options: ['Backyard camping', 'Water balloon fighting', 'Hiking', 'Night swimming', 'Ice skating'],
  color: 4
}, {
  question: 'What would ^name^ like to be known for? \ud83c\udfc6',
  options: ['Music', 'Scientific achievements', 'Crazy adventures', 'Unique style', 'Art'],
  color: 5
}, {
  question: 'Which one is ^name^\'s happy place? \ud83c\udf08',
  options: ['Cinema', 'Home', 'The beach', 'Gym', 'School'],
  color: 6
}, {
  question: 'How many pairs of shoes does ^name^ own? \ud83d\udc5f',
  options: ['1 pair', '5 pairs', '10 pairs', '+20 pairs'],
  color: 7
}, {
  question: 'Does ^name^ believe in aliens? \ud83d\udef8',
  options: ['Definitely', 'Possibly', 'Not really'],
  color: 0
}, {
  question: 'How many siblings does ^name^ have?',
  options: ['Only child', '1', '2', '3', '4', '+5'],
  color: 1
}, {
  question: 'If ^name^ were an animal, which one would it be?',
  options: ['Lion \ud83e\udd81', 'Eagle \ud83e\udd85', 'Bear \ud83d\udc3b', 'Dolphin \ud83d\udc2c', 'Shark \ud83e\udd88'],
  color: 2
}, {
  question: 'Which one is ^name^?',
  options: ['Creator', 'Follower'],
  color: 3
}, {
  question: 'Does ^name^ like to cook? \ud83c\udf73',
  options: ['Loves it', 'Sometimes', 'Not at all'],
  color: 4
}, {
  question: 'How many hours per day does ^name^ spend on TikTok? \u231b\ufe0f',
  options: ['None at all', '1 hour', '4 hours', 'Day-and-night'],
  color: 5
}, {
  question: 'Which one is ^name^\'s ultimate dream job? \ud83e\udd29',
  options: ['Doctor', 'YouTuber', 'Astronaut', 'Fashion model', 'TikToker'],
  color: 6
}, {
  question: 'What is ^name^\'s most hated food? \ud83e\udd22',
  options: ['Olives', 'Pickles', 'Sushi', 'Eggplant', 'Avocados'],
  color: 7
}, {
  question: 'What is one thing ^name^ cannot live without? \ud83d\ude35',
  options: ['Wi-Fi', 'Phone', 'Pet', 'Coffee'],
  color: 0
}, {
  question: 'What book has impacted ^name^ the most? \ud83d\udcda',
  options: ['Harry Potter', 'The Hunger Games', 'To Kill a Mockingbird', 'I\'ll Give You the Sun', 'The Fault in Our Stars'],
  color: 1
}, {
  question: 'How many countries has ^name^ been to? \ud83c\udf0e',
  options: ['1', '3', '5', '+10'],
  color: 2
}, {
  question: '\u270d\ufe0f Add your own question',
  options: ['', ''],
  color: 3
}]

export const afQuestionsEnglish = [{
  question: 'Which one is ^name^\'s favorite food?',
  options: ['Pizza \ud83c\udf55', 'Burger \ud83c\udf54', 'Sushi \ud83c\udf63', 'Taco \ud83c\udf2e', 'Ramen \ud83c\udf5c'],
  color: 0
}, {
  question: 'How long was ^name^\'s longest relationship? \ud83d\udc95',
  options: ['A week', 'A month', 'Two years', 'And counting'],
  color: 1
}, {
  question: 'What is one weird talent ^name^ has?',
  options: ['Eyebrow dancing', 'Epic tongue tricks', 'Moving eyes independently', 'Wiggling ears'],
  color: 2
}, {
  question: 'What does ^name^ dislike the most? \ud83d\ude21',
  options: ['Going to the dentist', 'Slow internet', 'Loud phone games', 'Homework'],
  color: 3
}, {
  question: 'If ^name^ could have one superpower, which would it be?',
  options: ['Flight', 'Invisibility', 'Teleportation', 'Telepathy', 'Super speed'],
  color: 4
}, {
  question: 'Which celeb would ^name^ like as a sibling?',
  options: ['Zendaya', 'Billie Eilish', 'Lil Nas X', 'Dua Lipa', 'Justin Bieber'],
  color: 5
}, {
  question: 'Where does ^name^ spend the most time? \ud83d\udcf1',
  options: ['FYP (For you page)', 'Feed', 'Reels', 'Stories', 'Explore'],
  color: 6
}, {
  question: 'Where does ^name^ want to travel the most? \ud83c\udf0e',
  options: ['Paris', 'New York', 'Bali', 'Tokyo', 'Tulum'],
  color: 7
}, {
  question: 'How tall is ^name^?',
  options: ['Less than 5\'3ft (160cm)', '5\'4ft (161cm) - 5\'8ft (172cm)', '5\'9ft (173cm) - 5\'11ft (181cm)', '6\'0ft (182cm) and up'],
  color: 0
}, {
  question: 'When is ^name^\'s birthday? \ud83c\udf82',
  options: ['September 9th', 'July 7th', 'March 10th', 'February 24th', 'September 19th'],
  color: 1
}, {
  question: 'What is ^name^\'s favorite song right now? \ud83c\udfa7',
  options: ['Song 1', 'Song 2'],
  color: 2
}, {
  question: 'Does ^name^ believe in ghosts? \ud83d\udc7b',
  options: ['Big time', 'A little', 'Not at all'],
  color: 3
}, {
  question: 'How old is ^name^?',
  options: ['18', '20', '22', '24', '26'],
  color: 4
}, {
  question: 'How many times does ^name^ workout per week? \ud83d\udcaa',
  options: ['Once', '2 to 3 times', 'Four times', 'Every day', 'Never'],
  color: 5
}, {
  question: 'Does ^name^ eat his veggies? \ud83e\udd57',
  options: ['Every bit', 'Barely', 'By no means'],
  color: 6
}, {
  question: 'Which color are ^name^\'s eyes? \ud83d\udc41',
  options: ['Blue', 'Amber', 'Brown', 'Hazel', 'Green'],
  color: 7
}, {
  question: 'Does ^name^ like to nap? \ud83d\ude34',
  options: ['Very much', 'Sometimes', 'Definitely not'],
  color: 0
}, {
  question: 'Which is ^name^\'s natural hair color? \ud83e\udd84',
  options: ['Black', 'Dark brown', 'Light brown', 'Blond', 'Gray', 'Red'],
  color: 2
}, {
  question: 'Does ^name^ sing in the shower? \ud83c\udfa4',
  options: ['All the time', 'Sometimes', 'Never'],
  color: 3
}, {
  question: 'What has been the most fun activity in ^name^\'s life so far? \ud83e\udd2a',
  options: ['Backyard camping', 'Water balloon fighting', 'Hiking', 'Night swimming', 'Ice skating'],
  color: 4
}, {
  question: 'What would ^name^ like to be known for? \ud83c\udfc6',
  options: ['Music', 'Scientific achievements', 'Crazy adventures', 'Unique style', 'Art'],
  color: 5
}, {
  question: 'Which one is ^name^\'s happy place? \ud83c\udf08',
  options: ['Cinema', 'Home', 'The beach', 'Gym', 'School'],
  color: 6
}, {
  question: 'How many pairs of shoes does ^name^ own? \ud83d\udc5f',
  options: ['1 pair', '5 pairs', '10 pairs', '+20 pairs'],
  color: 7
}, {
  question: 'Does ^name^ believe in aliens? \ud83d\udef8',
  options: ['Definitely', 'Possibly', 'Not really'],
  color: 0
}, {
  question: 'How many siblings does ^name^ have?',
  options: ['Only child', '1', '2', '3', '4', '+5'],
  color: 1
}, {
  question: 'If ^name^ were an animal, which one would it be?',
  options: ['Lion \ud83e\udd81', 'Eagle \ud83e\udd85', 'Bear \ud83d\udc3b', 'Dolphin \ud83d\udc2c', 'Shark \ud83e\udd88'],
  color: 2
}, {
  question: 'Which one is ^name^?',
  options: ['Creator', 'Follower'],
  color: 3
}, {
  question: 'Does ^name^ like to cook? \ud83c\udf73',
  options: ['Loves it', 'Sometimes', 'Not at all'],
  color: 4
}, {
  question: 'How many hours per day does ^name^ spend on TikTok? \u231b\ufe0f',
  options: ['None at all', '1 hour', '4 hours', 'Day-and-night'],
  color: 5
}, {
  question: 'Which one is ^name^\'s ultimate dream job? \ud83e\udd29',
  options: ['Doctor', 'YouTuber', 'Astronaut', 'Fashion model', 'TikToker'],
  color: 6
}, {
  question: 'What is ^name^\'s most hated food? \ud83e\udd22',
  options: ['Olives', 'Pickles', 'Sushi', 'Eggplant', 'Avocados'],
  color: 7
}, {
  question: 'What is one thing ^name^ cannot live without? \ud83d\ude35',
  options: ['Wi-Fi', 'Phone', 'Pet', 'Coffee'],
  color: 0
}, {
  question: 'What book has impacted ^name^ the most? \ud83d\udcda',
  options: ['Harry Potter', 'The Hunger Games', 'To Kill a Mockingbird', 'I\'ll Give You the Sun', 'The Fault in Our Stars'],
  color: 1
}, {
  question: 'How many countries has ^name^ been to? \ud83c\udf0e',
  options: ['1', '3', '5', '+10'],
  color: 2
}, {
  question: '\u270d\ufe0f Add your own question',
  options: ['', ''],
  color: 3
}]

export const auQuestionsEnglish = [{
  question: 'Which one is ^name^\'s favorite food?',
  options: ['Pizza \ud83c\udf55', 'Burger \ud83c\udf54', 'Sushi \ud83c\udf63', 'Taco \ud83c\udf2e', 'Ramen \ud83c\udf5c'],
  color: 0
}, {
  question: 'How long was ^name^\'s longest relationship? \ud83d\udc95',
  options: ['A week', 'A month', 'Two years', 'And counting'],
  color: 1
}, {
  question: 'What is one weird talent ^name^ has?',
  options: ['Eyebrow dancing', 'Epic tongue tricks', 'Moving eyes independently', 'Wiggling ears'],
  color: 2
}, {
  question: 'What does ^name^ dislike the most? \ud83d\ude21',
  options: ['Going to the dentist', 'Slow internet', 'Loud phone games', 'Homework'],
  color: 3
}, {
  question: 'If ^name^ could have one superpower, which would it be?',
  options: ['Flight', 'Invisibility', 'Teleportation', 'Telepathy', 'Super speed'],
  color: 4
}, {
  question: 'Which celeb would ^name^ like as a sibling?',
  options: ['Zendaya', 'Billie Eilish', 'Lil Nas X', 'Dua Lipa', 'Justin Bieber'],
  color: 5
}, {
  question: 'Where does ^name^ spend the most time? \ud83d\udcf1',
  options: ['FYP (For you page)', 'Feed', 'Reels', 'Stories', 'Explore'],
  color: 6
}, {
  question: 'Where does ^name^ want to travel the most? \ud83c\udf0e',
  options: ['Paris', 'New York', 'Bali', 'Tokyo', 'Tulum'],
  color: 7
}, {
  question: 'How tall is ^name^?',
  options: ['Less than 5\'3ft (160cm)', '5\'4ft (161cm) - 5\'8ft (172cm)', '5\'9ft (173cm) - 5\'11ft (181cm)', '6\'0ft (182cm) and up'],
  color: 0
}, {
  question: 'When is ^name^\'s birthday? \ud83c\udf82',
  options: ['September 9th', 'July 7th', 'March 10th', 'February 24th', 'September 19th'],
  color: 1
}, {
  question: 'What is ^name^\'s favorite song right now? \ud83c\udfa7',
  options: ['Song 1', 'Song 2'],
  color: 2
}, {
  question: 'Does ^name^ believe in ghosts? \ud83d\udc7b',
  options: ['Big time', 'A little', 'Not at all'],
  color: 3
}, {
  question: 'How old is ^name^?',
  options: ['18', '20', '22', '24', '26'],
  color: 4
}, {
  question: 'How many times does ^name^ workout per week? \ud83d\udcaa',
  options: ['Once', '2 to 3 times', 'Four times', 'Every day', 'Never'],
  color: 5
}, {
  question: 'Does ^name^ eat his veggies? \ud83e\udd57',
  options: ['Every bit', 'Barely', 'By no means'],
  color: 6
}, {
  question: 'Which color are ^name^\'s eyes? \ud83d\udc41',
  options: ['Blue', 'Amber', 'Brown', 'Hazel', 'Green'],
  color: 7
}, {
  question: 'Does ^name^ like to nap? \ud83d\ude34',
  options: ['Very much', 'Sometimes', 'Definitely not'],
  color: 0
}, {
  question: 'Which is ^name^\'s natural hair color? \ud83e\udd84',
  options: ['Black', 'Dark brown', 'Light brown', 'Blond', 'Gray', 'Red'],
  color: 2
}, {
  question: 'Does ^name^ sing in the shower? \ud83c\udfa4',
  options: ['All the time', 'Sometimes', 'Never'],
  color: 3
}, {
  question: 'What has been the most fun activity in ^name^\'s life so far? \ud83e\udd2a',
  options: ['Backyard camping', 'Water balloon fighting', 'Hiking', 'Night swimming', 'Ice skating'],
  color: 4
}, {
  question: 'What would ^name^ like to be known for? \ud83c\udfc6',
  options: ['Music', 'Scientific achievements', 'Crazy adventures', 'Unique style', 'Art'],
  color: 5
}, {
  question: 'Which one is ^name^\'s happy place? \ud83c\udf08',
  options: ['Cinema', 'Home', 'The beach', 'Gym', 'School'],
  color: 6
}, {
  question: 'How many pairs of shoes does ^name^ own? \ud83d\udc5f',
  options: ['1 pair', '5 pairs', '10 pairs', '+20 pairs'],
  color: 7
}, {
  question: 'Does ^name^ believe in aliens? \ud83d\udef8',
  options: ['Definitely', 'Possibly', 'Not really'],
  color: 0
}, {
  question: 'How many siblings does ^name^ have?',
  options: ['Only child', '1', '2', '3', '4', '+5'],
  color: 1
}, {
  question: 'If ^name^ were an animal, which one would it be?',
  options: ['Lion \ud83e\udd81', 'Eagle \ud83e\udd85', 'Bear \ud83d\udc3b', 'Dolphin \ud83d\udc2c', 'Shark \ud83e\udd88'],
  color: 2
}, {
  question: 'Which one is ^name^?',
  options: ['Creator', 'Follower'],
  color: 3
}, {
  question: 'Does ^name^ like to cook? \ud83c\udf73',
  options: ['Loves it', 'Sometimes', 'Not at all'],
  color: 4
}, {
  question: 'How many hours per day does ^name^ spend on TikTok? \u231b\ufe0f',
  options: ['None at all', '1 hour', '4 hours', 'Day-and-night'],
  color: 5
}, {
  question: 'Which one is ^name^\'s ultimate dream job? \ud83e\udd29',
  options: ['Doctor', 'YouTuber', 'Astronaut', 'Fashion model', 'TikToker'],
  color: 6
}, {
  question: 'What is ^name^\'s most hated food? \ud83e\udd22',
  options: ['Olives', 'Pickles', 'Sushi', 'Eggplant', 'Avocados'],
  color: 7
}, {
  question: 'What is one thing ^name^ cannot live without? \ud83d\ude35',
  options: ['Wi-Fi', 'Phone', 'Pet', 'Coffee'],
  color: 0
}, {
  question: 'What book has impacted ^name^ the most? \ud83d\udcda',
  options: ['Harry Potter', 'The Hunger Games', 'To Kill a Mockingbird', 'I\'ll Give You the Sun', 'The Fault in Our Stars'],
  color: 1
}, {
  question: 'How many countries has ^name^ been to? \ud83c\udf0e',
  options: ['1', '3', '5', '+10'],
  color: 2
}, {
  question: '\u270d\ufe0f Add your own question',
  options: ['', ''],
  color: 3
}]
